module.exports = __webpack_public_path__ + "static/media/top_banner_9.874e0a05.png";